import { useQuery } from '@tanstack/react-query';

import { getConversationTasks } from '~/views/alfred/research/services/conversations-service';

export const QUERY_KEY_CONVERSATION_TASK = 'QUERY_KEY_CONVERSATION_TASK';

export const useConversationTask = (conversationId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_CONVERSATION_TASK, conversationId],
    queryFn: async ({ signal }) => {
      const result = await getConversationTasks(conversationId, signal);
      return result.data;
    },
  });
